/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Col, Row, Input, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BibliotecaAPI, ReservaAPI } from '../../../../shared/http-requests';
import {
    APIHelper,
    ArrayHelper,
    ToastifyHelper,
} from '../../../../shared/helpers';
import Login from '../../pages/auth/Login';
import {
    ConfirmationModal,
    SpinnerConstructor,
} from '../../../../shared/components';
import { Store } from '../../../../store';
import { AuthPersist } from '../../../../store/ducks/authPersist';
import { AuthSession } from '../../../../store/ducks/auth';
import { RESERVAS_COMBOS } from '../../consts';
import { usePrefiterParams } from '../../../../shared/hooks';

let deslogarAposReserva = false;

const DadosAcervoReserva = ({ codAcervo, referencia = [] }) => {
    const { t } = useTranslation();
    const { status } = useSelector(state => state.pageConfig);
    const {
        data: { restringe_ui_res_se_usu_logado },
    } = useSelector(state => state.instituicao);
    const userPersist = useSelector(state => state.authPersist.user);
    const userSession = useSelector(state => state.auth.user);
    const [quantidadesReserva, setQuantidadesReserva] = useState(false);
    const [exemplaresReserva, setExemplaresReserva] = useState(false);
    const [dadosSelecionados, setDadosSelecionados] = useState([]);
    const [loadingReserva, setLoadingReserva] = useState(false);
    const [modalConfirmacaoOpen, setModalConfirmacaoOpen] = useState(false);
    const [userLibraries, setUserLibraries] = useState(null);
    const [dadosCombos, setDadosCombos] = useState({
        biblioteca: [],
        volume: [],
        tomo: [],
        parte: [],
        material: [],
        localizacao: [],
    });
    const { getAll } = usePrefiterParams();
    const isAuthenticated = !!(userSession || userPersist);

    //? Busca as informacoes inciais da tela da API
    useEffect(() => {
        if (status) {
            const { id: campus, id_biblioteca: bibliotecas } = getAll();
            ReservaAPI.buscarInformacoesIniciaisReserva(
                codAcervo,
                campus,
                bibliotecas,
            )
                .then(({ data: { exemplares, reservas } }) => {
                    setExemplaresReserva(exemplares);
                    setQuantidadesReserva(reservas);
                })
                .catch(error => APIHelper.tratarErro(error));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, codAcervo]);

    //? Chamado assim que os exemplares carregarem para setar apenas o combo de unidade de informação
    useEffect(() => {
        if (
            exemplaresReserva &&
            !exemplaresReserva.erro &&
            !getDadoSelecionado('biblioteca')
        ) {
            let bibs = ArrayHelper.distinctByProperty(
                'codigo',
                exemplaresReserva.map(
                    ({
                        cod_biblioteca,
                        desc_biblioteca,
                        reserva_localizacao,
                        reserva_mat_adicional,
                    }) => ({
                        codigo: cod_biblioteca,
                        descricao: desc_biblioteca,
                        localizacao: reserva_localizacao,
                        material: reserva_mat_adicional,
                    }),
                ),
            ).sort((a, b) => a.descricao.localeCompare(b.descricao));
            if (!bibs || bibs.length === 0) {
                setExemplaresReserva({
                    erro: true,
                    msg: t(
                        'ReservaCanceladaNaoExisteExemplarSituacaoPermiteReserva',
                    ),
                });
                return;
            }
            if (userLibraries !== null) {
                /**
                 * Valida bibliotecas que o usuario tem acesso
                 */
                if (
                    restringe_ui_res_se_usu_logado &&
                    restringe_ui_res_se_usu_logado === '1' &&
                    isAuthenticated
                ) {
                    bibs = bibs.filter(b =>
                        userLibraries.some(
                            ul => ul.cod_biblioteca === b.codigo,
                        ),
                    );
                }
            }
            setDadosCombos(d => ({ ...d, biblioteca: bibs }));
            handleSelectCombo('biblioteca', bibs && bibs[0] && bibs[0].codigo);
        }
    }, [exemplaresReserva, userLibraries]);

    //? Chamado toda vez que alguma opção nova é selecionada para remontar as opcoes das combos
    useEffect(() => {
        if (dadosSelecionados.length) {
            //* Filtra os exemplares com base nos dados selecionados
            const exemplares = filtrarInformacoesExemplares();
            //* Remonta as opções das combos que não possuem valor selecionado
            const aux = { ...dadosCombos };
            Object.keys(RESERVAS_COMBOS)
                .filter(filtrarLocalizacaoMaterial)
                .forEach(nomeCombo => {
                    if (!dadosSelecionados.find(d => d.key === nomeCombo)) {
                        const dadosComboNovo = ArrayHelper.distinctByProperty(
                            'codigo',
                            exemplares.map(ex => ({
                                codigo: ex[RESERVAS_COMBOS[nomeCombo]],
                                descricao: getDescricaoCombo(nomeCombo, ex),
                            })),
                        ).sort(ArrayHelper.sortByProperty('codigo', 'C', true));
                        aux[nomeCombo] = dadosComboNovo;
                    }
                });
            setDadosCombos(aux);
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dadosSelecionados, t]);

    useEffect(() => {
        if (
            restringe_ui_res_se_usu_logado &&
            restringe_ui_res_se_usu_logado === '1' &&
            isAuthenticated
        ) {
            (async () => {
                try {
                    const response = await BibliotecaAPI.getUserLibraries();
                    if (response) {
                        const { data } = await response;
                        if (data) {
                            setUserLibraries(data);
                            return;
                        }
                        setUserLibraries([]);
                    }
                } catch (e) {
                    setUserLibraries([]);
                }
            })();
        } else {
            setUserLibraries([]);
        }
    }, [restringe_ui_res_se_usu_logado, isAuthenticated]);

    const getDadoSelecionado = chave =>
        dadosSelecionados.find(dado => dado.key === chave);

    const getDescricaoCombo = (nomeCombo, data) => {
        switch (nomeCombo) {
            case 'volume':
                return data.volume === '99999'
                    ? t('Unico')
                    : `V. ${data.volume}`;
            case 'tomo':
                return data.tomo_exemplar === '99999'
                    ? t('Unico')
                    : `T. ${data.tomo_exemplar}`;
            case 'parte':
                return data.parte === '99999'
                    ? t('Unico')
                    : `Pt. ${data.parte}`;
            case 'material':
                return data.mat_adicional === '0'
                    ? t('MaterialPrincipal')
                    : t('MaterialAdicional');
            case 'localizacao':
                return data.cod_local_exemplar === '-1'
                    ? t('Todas')
                    : data.desc_local_exemplar;
            default:
                return null;
        }
    };

    const filtrarLocalizacaoMaterial = nomeCombo => {
        const bib =
            dadosCombos.biblioteca.filter(b => {
                return b.codigo === getDadoSelecionado('biblioteca')?.value;
            })[0] || null;

        if (!bib) return true;
        if (nomeCombo === 'localizacao' && bib.localizacao === 'N')
            return false;
        if (nomeCombo === 'material' && bib.material === 'N') return false;
        return true;
    };

    const getAvisoReserva = () => {
        const bibliotecaSelecionada = getDadoSelecionado('biblioteca');
        if (
            bibliotecaSelecionada &&
            quantidadesReserva &&
            !quantidadesReserva.find(
                qtd =>
                    parseInt(qtd.cod_biblioteca, 10) ===
                    parseInt(bibliotecaSelecionada.value, 10),
            )
        )
            return (
                <div className="pad10 rad5 bkazul branco b10 animated fadeIn s14 sombraPadrao">
                    <FontAwesomeIcon icon="info-circle" className="r5" />
                    {t('NaoExisteReservaUnidadeInformacao')}
                </div>
            );
        return null;
    };

    const handleSelectCombo = (name, value) => {
        let dadosSelecionadosMod = [];
        let isModificacao = false;

        //* Adiciona ou troca no array de dados selecionados o valor
        if (!getDadoSelecionado(name)) {
            dadosSelecionadosMod = [...dadosSelecionados, { key: name, value }];
        } else {
            dadosSelecionadosMod = dadosSelecionados.map(dado => {
                return dado.key === name ? { key: name, value } : dado;
            });
            isModificacao = true;
        }
        //* Se estiver alterando um dado que já foi selecionado, remove todos os dados selecionados após o indice do dado alterado
        if (isModificacao) {
            const indexArg = dadosSelecionadosMod.findIndex(
                d => d.key === name,
            );
            dadosSelecionadosMod = dadosSelecionadosMod.filter(
                (dado, index) => index <= indexArg && dado,
            );
        }
        setDadosSelecionados(dadosSelecionadosMod);
    };

    const filtrarInformacoesExemplares = () =>
        exemplaresReserva.filter(ex => {
            return dadosSelecionados.every(selecao => {
                return ex[RESERVAS_COMBOS[selecao.key]] === selecao.value;
            });
        });

    //Primeiro valida a fila para depois enviar reserva
    const validarFilaReserva = () => {
        setLoadingReserva(true);

        ReservaAPI.validarFilaReserva(
            codAcervo,
            getDadoSelecionado('biblioteca').value,
            getDadoSelecionado('volume').value,
            getDadoSelecionado('tomo').value,
            getDadoSelecionado('parte').value,
            filtrarLocalizacaoMaterial('material')
                ? getDadoSelecionado('material')?.value
                : null,
            filtrarLocalizacaoMaterial('localizacao')
                ? getDadoSelecionado('localizacao')?.value
                : null,
        )
            .then(response => {
                const { existeFila } = response.data;
                if (existeFila) {
                    setModalConfirmacaoOpen(true);
                    setLoadingReserva(false);
                } else {
                    enviarReserva();
                }
            })
            .catch(error => {
                setLoadingReserva(false);
                APIHelper.tratarErro(error);

                if (deslogarAposReserva) deslogar();
            });
    };

    const enviarReserva = () => {
        if (
            dadosSelecionados.length <
            Object.keys(RESERVAS_COMBOS).filter(filtrarLocalizacaoMaterial)
                .length
        ) {
            ToastifyHelper.warning(t('SelecioneTodasOpcoesReserva'), {});
            return;
        }
        setLoadingReserva(true);
        ReservaAPI.gravarReserva(
            codAcervo,
            getDadoSelecionado('biblioteca').value,
            getDadoSelecionado('volume').value,
            getDadoSelecionado('tomo').value,
            getDadoSelecionado('parte').value,
            filtrarLocalizacaoMaterial('material')
                ? getDadoSelecionado('material')?.value
                : null,
            filtrarLocalizacaoMaterial('localizacao')
                ? getDadoSelecionado('localizacao')?.value
                : null,
        )
            .then(() => {
                ToastifyHelper.success(t('ReservaSucesso'));

                //? Incrementa a quantidade de reservas da biblioteca selecionada
                let quantAux = quantidadesReserva;
                const bibSelecionada = getDadoSelecionado('biblioteca');
                if (
                    quantAux.find(
                        elem => elem.cod_biblioteca === bibSelecionada.value,
                    )
                )
                    quantAux = quantAux.map(elem => {
                        if (elem.cod_biblioteca === bibSelecionada.value)
                            elem.total = parseInt(elem.total, 10) + 1;
                        return elem;
                    });
                else
                    quantAux = [
                        ...quantAux,
                        { cod_biblioteca: bibSelecionada.value, total: 1 },
                    ];
                setQuantidadesReserva(quantAux);
            })
            .catch(error => APIHelper.tratarErro(error))
            .finally(() => {
                setDadosSelecionados(d =>
                    d.filter(dado => dado.key === 'biblioteca'),
                ); //* Reseta as combos
                setLoadingReserva(false);

                if (deslogarAposReserva) deslogar();
            });
    };

    const deslogar = () => {
        deslogarAposReserva = false;

        Store.dispatch(AuthPersist.logout());
        Store.dispatch(AuthSession.logout());
    };

    const renderLoadingFeedback = () => {
        return (
            <Col
                xs="12"
                md="7"
                className="b-solid-right b-w1 b-tema40 text-center"
            >
                <div className="p-5 mt-3">
                    <SpinnerConstructor
                        visible
                        height={70}
                        width={70}
                        className="cortxt70 s20"
                    />
                </div>
            </Col>
        );
    };

    useEffect(() => {
        if(dadosCombos?.volume?.length === 1 && !getDadoSelecionado('volume')?.value) {
            handleSelectCombo('volume', dadosCombos?.volume[0]?.codigo || '99999');
        }
        if(dadosCombos?.tomo?.length === 1 && !getDadoSelecionado('tomo')?.value){
            handleSelectCombo('tomo', dadosCombos?.tomo[0]?.codigo || '99999');
        }
        if(dadosCombos?.parte?.length === 1 && !getDadoSelecionado('parte')?.value){
            handleSelectCombo('parte', dadosCombos?.parte[0]?.codigo || '99999');
        }
        if(dadosCombos?.material?.length === 1 && !getDadoSelecionado('material')?.value){
            handleSelectCombo('material', dadosCombos?.material[0]?.codigo || '0');
        }
    }, [dadosCombos?.volume, dadosCombos?.tomo, dadosCombos?.parte, dadosCombos?.material]);

    const renderFormContent = () => {
        if (exemplaresReserva.erro) {
            return (
                <Col
                    xs="12"
                    md="7"
                    className="b-solid-right b-w1 b-tema40 text-center"
                >
                    <div className="p-5 animated fadeIn">
                        <FontAwesomeIcon
                            icon="exclamation-triangle"
                            className="laranja s20 r10"
                        />
                        <span className="laranja s17">
                            {t(exemplaresReserva.msg)}
                        </span>
                    </div>
                </Col>
            );
        }


        return (
            <Col xs="12" md="7" className="b-solid-right b-w1 b-tema40 ">
                <Row className="b-w1 b-cinza2 b-solid-bottom pad5">
                    <Col md="12">
                        <label className="f500 cortxt s13">
                            {t('ParaReservarPreencha')}:
                        </label>
                    </Col>
                </Row>

                {Object.keys(RESERVAS_COMBOS)
                    .filter(filtrarLocalizacaoMaterial)
                    .map(nomeCombo =>
                        ['volume', 'tomo', 'parte', 'material'].includes(nomeCombo) &&
                        dadosCombos[nomeCombo]?.length === 1 ? '' : (
                            <Row
                                className="b-w1 b-cinza2 b-solid-bottom p-2 animated fadeIn"
                                key={`row-${nomeCombo}`}
                            >
                                <Col md="3" xs="12" className="pb-md-0 pb-2">
                                    <label className="f500 preto70 s13">
                                        {t(
                                            nomeCombo[0].toUpperCase() +
                                            nomeCombo.slice(1),
                                        )}
                                        :
                                    </label>
                                </Col>
                                <Col md="9" xs="12">
                                    {nomeCombo === 'biblioteca' &&
                                    restringe_ui_res_se_usu_logado &&
                                    restringe_ui_res_se_usu_logado === '1' &&
                                    isAuthenticated &&
                                    dadosCombos[nomeCombo]?.length === 0 ? (
                                        <div className="pad10 rad5 bkazul branco b10 animated fadeIn s14 sombraPadrao">
                                            <FontAwesomeIcon
                                                icon="info-circle"
                                                className="r5"
                                            />
                                            {t('VoceNaoPossuiNenhumaUnidade')}
                                        </div>
                                    ) : (
                                        <InputReserva
                                            t={t}
                                            name={nomeCombo}
                                            valor={getDadoSelecionado(nomeCombo)}
                                            dados={dadosCombos[nomeCombo]}
                                            selectCallback={handleSelectCombo}
                                        />
                                    )}
                                </Col>
                            </Row>
                        )
                    )}
                <Row className="mt-3">
                    <Col md={{ size: 10, offset: 1 }} xs="12">
                        {dadosSelecionados.length >=
                        Object.keys(RESERVAS_COMBOS).filter(
                            filtrarLocalizacaoMaterial,
                        ).length ? (
                            <Login
                                embedded
                                labelAcessarAlternativo={t('ConfirmarReserva')}
                                loginCallback={() => {
                                    deslogarAposReserva = true;
                                    validarFilaReserva();
                                }}
                                altRender={auth =>
                                    auth ? (
                                        <div className="text-center p-3 animated fadeIn">
                                            {loadingReserva ? (
                                                <div>
                                                    <SpinnerConstructor
                                                        height={40}
                                                        width={40}
                                                        className="preto70 mb-2"
                                                        visible
                                                    />
                                                    <span className="f300 preto80 s14">
                                                        {t('Aguarde')}...
                                                    </span>
                                                </div>
                                            ) : (
                                                <Button
                                                    className="btn-generic--primeiro ml-0"
                                                    disabled={
                                                        dadosSelecionados.length <
                                                        Object.keys(
                                                            RESERVAS_COMBOS,
                                                        ).filter(
                                                            filtrarLocalizacaoMaterial,
                                                        ).length
                                                    }
                                                    onClick={() =>
                                                        validarFilaReserva()
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon="check"
                                                        className="r10"
                                                    />
                                                    {t('ConfirmarReserva')}
                                                </Button>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="pad10">
                                            <FontAwesomeIcon
                                                icon="exclamation-circle"
                                                className="laranja s14 r10"
                                            />
                                            <span className="preto90 s14">
                                                {t(
                                                    'NecessarioLoginFazerReserva',
                                                )}
                                            </span>
                                        </div>
                                    )
                                }
                            />
                        ) : (
                            <div className="text-center">
                                <Button
                                    className="btn-generic--primeiro ml-0"
                                    disabled
                                >
                                    <FontAwesomeIcon
                                        icon="check"
                                        className="r10"
                                    />
                                    {t('ConfirmarReserva')}
                                </Button>
                            </div>
                        )}
                        <ConfirmationModal
                            isOpen={modalConfirmacaoOpen}
                            setOpen={setModalConfirmacaoOpen}
                            content={
                                <p className="s16 f500">
                                    {t('MaterialNaoDisponivelFilaEspera')}
                                </p>
                            }
                            onConfirmar={() => {
                                setModalConfirmacaoOpen(false);
                                enviarReserva();
                            }}
                            onCancelar={() => {
                                setModalConfirmacaoOpen(false);

                                setDadosSelecionados(d =>
                                    d.filter(dado => dado.key === 'biblioteca'),
                                ); //* Reseta as combos

                                if (deslogarAposReserva) deslogar();
                            }}
                        />
                    </Col>
                </Row>
            </Col>
        );
    };

    return (
        <Row className="pad5 animated fadeIn">
            <Col xs="12" className="d-md-none d-xs-block pt-3">
                {getAvisoReserva()}
                <Row className="b-w1 b-solid-top b-cinza2 pad5">
                    <Col xs="12" className="preto80 f500 s14">
                        <FontAwesomeIcon icon="angle-right" className="r10" />
                        <span className="s15"
                              dangerouslySetInnerHTML={{
                                  __html:referencia && referencia.desc_titulo
                              }}
                        />
                    </Col>
                </Row>
                <Row className="b-w1 b-solid-top b-cinza2 pad5">
                    <Col xs="12" className="preto60 f400 s12">
                        <FontAwesomeIcon icon="angle-right" className="r10" />
                        <span className="s13 font-italic"
                              dangerouslySetInnerHTML={{
                                  __html: referencia && referencia.referencia,
                              }}
                        />
                    </Col>
                </Row>
            </Col>
            {exemplaresReserva ? renderFormContent() : renderLoadingFeedback()}
            <Col md="5" className="d-md-block d-none pt-3">
                {getAvisoReserva()}
                <Row className="b-w1 b-solid-top b-cinza2 pad5">
                    <Col md="12" className="preto80 f500 s14">
                        <FontAwesomeIcon icon="angle-right" className="r10" />
                        <span className="s15"
                              dangerouslySetInnerHTML={{
                                  __html: referencia && referencia.desc_titulo
                              }}
                        />
                    </Col>
                </Row>
                <Row className="b-w1 b-solid-top b-cinza2 pad5">
                    <Col md="12" className="preto60 f400 s12">
                        <FontAwesomeIcon icon="angle-right" className="r10" />
                        <span
                            className="s13 font-italic"
                            dangerouslySetInnerHTML={{
                                __html: referencia && referencia.referencia,
                            }}
                        />
                    </Col>
                </Row>
            </Col>
            <Col md="12" />
        </Row>
    );
};

export const InputReserva = ({ valor, name, dados, selectCallback }) => {
    const { t } = useTranslation();
    const value = valor ? valor.value || '99999' : 'S';

    useEffect(() => {
        if (dados && dados.length === 1 && !valor) {
            selectCallback(name, dados[0].codigo || '99999');
        }
    }, [dados, name, valor, selectCallback]);

    return dados.length === 1 ? (
        <p>{dados[0].descricao}</p>
    ) : (
        <Input
            type="select"
            name={name}
            className={`b-tema20 rad10 s14 ${
                value === 'S' ? 'cinza' : 'cortxt'
            }`}
            value={value}
            onChange={e => selectCallback(e.target.name, e.target.value)}
        >
            {name !== 'biblioteca' && dados.length > 1 && (
                <option disabled value="S">
                    {t('SelecioneOpcao')}...
                </option>
            )}
            {dados.map(row => (
                <option
                    key={`opt-${name}-${row.codigo}`}
                    className="preto70"
                    value={row.codigo || '99999'}
                >
                    {row.descricao}
                </option>
            ))}
        </Input>
    );
};

DadosAcervoReserva.defaultProps = {
    referencia: [],
};

DadosAcervoReserva.propTypes = {
    codAcervo: PropTypes.string.isRequired,
    referencia: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export default DadosAcervoReserva;
